
import { useTranslation } from 'react-i18next';

export default function Philosophy() {
  const { t } = useTranslation();

  return (
    <section id="philosophy" className="py-32 relative">
      <div className="max-w-[780px] mx-auto px-8 text-center space-y-10">
        <div className="relative">
          <div className="absolute inset-0 opacity-5">
            <div className="absolute top-0 left-1/4 w-32 h-32 border border-[#d4af37] rounded-full"></div>
            <div className="absolute bottom-0 right-1/4 w-24 h-24 border border-[#d4af37] rounded-full"></div>
          </div>

          <div className="relative z-10 space-y-8">
            <p className="text-lg text-[#d4af37] tracking-wide">{t('phil.label')}</p>

            <p className="text-3xl font-serif text-white leading-relaxed">
              {t('phil.main')}
            </p>

            <div className="pt-6 space-y-6">
              <p className="text-lg text-[#b8b8b8] leading-relaxed">
                {t('phil.p1')}
              </p>

              <p className="text-lg text-[#b8b8b8] leading-relaxed">
                {t('phil.p2')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
